/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import DatePicker from 'react-datepicker';
import { CalendarContainer } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './style.css';
// import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
// import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import en from 'date-fns/locale/en-GB';
import ar from 'date-fns/locale/ar-SA';

const CalenderLocalClock = ({
  isRTL,
  label,
  value,
  onChange,
  format = 'dd/MM/yyyy',
  time,
  width = 150,
  minDate,
  maxDate,
  ...rest
}: any) => {
  const locale = isRTL ? ar : en;

  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      dateFormat={format}
      locale={locale}
      minDate={minDate}
      maxDate={maxDate}
      showTimeSelect={time}
      timeFormat="HH:mm"
      calendarContainer={CalendarContainer}
      placeholderText={label}
      className="form-control"
    />
  );
};

export default CalenderLocalClock;
